import { render, staticRenderFns } from "./theme-button.vue?vue&type=template&id=063a4b25&scoped=true"
var script = {}
import style0 from "./theme-button.vue?vue&type=style&index=0&id=063a4b25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a4b25",
  null
  
)

export default component.exports